import * as moment from 'moment';
import * as actions from '../constants';
import { getBookingRange } from './bookings';
import { getHolidayRange } from './holidays';
import { getReservationRange } from './reservations';

/**
 * Fetch history calendar events for the specified month
 * @param {Number} year
 * @param {Number} month Zero indexed month (0-11)
 */
export const getMonth = (year, month, date = new Date()): any => async (
  dispatch,
) => {
  console.error("Don't use history.getMonth anymore!");
  dispatch({ year, month, type: actions.REQUEST_HISTORY_MONTH });
  try {
    const start = moment([year, month]);
    const end = moment(start).endOf('month');
    const [
      holidayResponse,
      reservationResponse,
      bookingResponse,
    ] = await Promise.all([
      dispatch(getHolidayRange(start, end)),
      dispatch(getReservationRange(start, end)),
      dispatch(getBookingRange(start, end, undefined, true)),
    ]);
    const result = {
      holidays: holidayResponse.error ? [] : holidayResponse.data,
      reservations: reservationResponse.error ? [] : reservationResponse.data,
      bookings: bookingResponse.error ? [] : bookingResponse.data,
    };
    dispatch({
      date,
      type: actions.RECEIVE_HISTORY_MONTH,
      data: result,
      error: false,
    });
    return result;
  } catch (err) {
    dispatch({
      type: actions.RECEIVE_HISTORY_MONTH,
      error: 'There was a problem fetching the monthly events',
    });
    return false;
  }
};

/**
 * Fetch history calendar events for the specified day
 * @param {Number} year
 * @param {Number} month Zero indexed month (0-11)
 * @param {Number} day
 */
export const getDay = (year, month, day, date = new Date()): any => async (
  dispatch,
) => {
  dispatch({ year, month, day, type: actions.REQUEST_HISTORY_DAY });
  try {
    const start = moment([year, month, day]);
    const end = moment(start).set({
      hour: 23,
      minute: 59,
      second: 59,
      millisecond: 999,
    });
    const response = await Promise.all([
      dispatch(getHolidayRange(start, end)),
      dispatch(getReservationRange(start, end)),
      dispatch(getBookingRange(start, end, undefined, true)),
    ]);
    const result = {
      holidays: response[0].error ? [] : response[0].data,
      reservations: response[1].error ? [] : response[1].data,
      bookings: response[2].error ? [] : response[2].data,
    };
    dispatch({
      date,
      type: actions.RECEIVE_HISTORY_DAY,
      data: result,
      error: false,
    });
    return result;
  } catch (err) {
    dispatch({
      type: actions.RECEIVE_HISTORY_DAY,
      error: 'There was a problem fetching the daily events',
    });
    return false;
  }
};
